import React from 'react'
import "./SubStyle.css"

const Acc_Financial = () => {
  return (
    <section className="OurServices">
     <h1 className="OurServices-title">Financial Analysis and Support</h1>
      <p className="OurServices-pera">Gain valuable insights into your business finances with expert analysis and practical guidance. We help you understand key financial indicators, improve profitability, manage costs, and make informed strategic decisions for sustainable growth.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Financial
